import React from 'react';
import { brand } from '../brand';

const SIZES = {
    sm: 'w-8 h-8',
    lg: 'w-14 h-14',
};

/**
 * App-shell logo for the current domain's brand.
 * Falls back to a colored document icon when the brand has no logo file.
 */
const BrandLogo = ({ size = 'sm' }) => {
    if (brand.logoUrl) {
        return <img src={brand.logoUrl} alt={brand.name} className={`${SIZES[size]} object-contain`} />;
    }

    return (
        <div
            className={`${SIZES[size]} rounded-xl flex items-center justify-center`}
            style={{ backgroundColor: brand.primaryColor }}
        >
            <svg className="w-3/5 h-3/5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
        </div>
    );
};

export default BrandLogo;
